
import { useEffect } from 'react';

const SecurityHeaders = () => {
  useEffect(() => {
    // NOTE: The following directives are IGNORED by browsers when delivered via
    // <meta http-equiv> and will emit console warnings if we include them here:
    //   - frame-ancestors  (CSP directive — meta-delivered CSPs must omit it)
    //   - X-Frame-Options
    //   - Strict-Transport-Security (HSTS)
    //   - X-Content-Type-Options (partially ignored via meta in some browsers)
    // These MUST be sent as real HTTP response headers. We ship them via
    // `public/_headers` at the hosting edge. Keep this file for the directives
    // that ARE honoured via meta (CSP without frame-ancestors, Referrer-Policy,
    // Permissions-Policy) as defense-in-depth.
    const metaTags = [
      { httpEquiv: 'Referrer-Policy', content: 'strict-origin-when-cross-origin' },
      {
        httpEquiv: 'Content-Security-Policy',
        content: [
          "default-src 'self'",
          // 'unsafe-inline' for scripts is currently required by Vite's runtime;
          // tighten further (nonces/hashes) once the build pipeline supports it.
          "script-src 'self' 'unsafe-inline' https://js.stripe.com https://*.stripe.com https://*.stripecdn.com https://*.stripe.network https://*.hcaptcha.com",
          "style-src 'self' 'unsafe-inline' https://js.stripe.com https://*.stripe.com https://*.stripecdn.com https://*.hcaptcha.com",
          "font-src 'self' data:",
          "img-src 'self' data: blob: https: ",
          "media-src 'self' blob: data:",
          "connect-src 'self' https://fqtpejnluzyjsiuibckn.supabase.co https://jfnkjpjryejjcrihwvlt.supabase.co https://api.lovable.dev https://api.stripe.com https://checkout.stripe.com https://r.stripe.com https://q.stripe.com https://m.stripe.com https://m.stripe.network https://checkout-cookies.stripe.com https://merchant-ui-api.stripe.com https://api.hcaptcha.com https://*.stripe.com https://*.stripe.network https://*.stripecdn.com https://*.hcaptcha.com wss://fqtpejnluzyjsiuibckn.supabase.co wss://jfnkjpjryejjcrihwvlt.supabase.co",
          "frame-src 'self' https://js.stripe.com https://checkout.stripe.com https://*.stripe.com https://*.stripe.network https://*.stripecdn.com https://*.hcaptcha.com",
          "worker-src 'self' blob:",
          // frame-ancestors intentionally omitted here — delivered via HTTP header in public/_headers.
          "object-src 'none'",
          "base-uri 'self'",
          "form-action 'self'",
          "upgrade-insecure-requests",
        ].join('; '),
      },
      { httpEquiv: 'Permissions-Policy', content: 'camera=(), microphone=(), geolocation=(), payment=(), usb=(), magnetometer=(), gyroscope=(), accelerometer=()' },
    ];

    metaTags.forEach(({ httpEquiv, content }) => {
      const meta = document.createElement('meta');
      meta.httpEquiv = httpEquiv;
      meta.content = content;
      document.head.appendChild(meta);
    });

    return () => {
      metaTags.forEach(({ httpEquiv }) => {
        const existingMeta = document.querySelector(`meta[http-equiv="${httpEquiv}"]`);
        if (existingMeta) {
          document.head.removeChild(existingMeta);
        }
      });
    };
  }, []);

  return null;
};

export default SecurityHeaders;

